export default __webpack_public_path__ + "static/media/undraw_chilling_re_4iq9.ccaa6091.svg";